"use client";

import { DisclaimerWithReadMore } from "@bfl-ui-toolkit/disclaimer-with-read-more";
import { IDisclaimer } from "../../interfaces/IAMCContent.interface";
import { dataLayer, CombinedClevertapProps } from "@repo/analytics/data-layer-utils";
import { selectLoginStatus, useAppSelector } from "@repo/global-store";

interface AMCDisclaimerProps {
  disclaimerData: IDisclaimer;
}

export const AMCDisclaimer: React.FC<AMCDisclaimerProps> = ({ disclaimerData }) => {
  const { disclaimertext, title } = disclaimerData;
  const loginStatus = useAppSelector(selectLoginStatus);

  const handleDisclaimerTrackEvent = (eventType: string) => {
    const payload = {
      component: "amc_disclaimer",
      element: "disclaimer_read_more_click",
      event: "click",
      event_type: eventType,
      destination_url: "NA",
      section_title: title,
      cta_text: "Read more",
      product_name: "bajaj_mutual_fund",
      category_name: "mutual_fund",
      page_type: "pdp",
      component_position: "",
      component_id: "amc_disclaimer",
    };

    dataLayer(loginStatus, payload, payload as unknown as CombinedClevertapProps);
  };

  const trackEvent = (payload?: { clickType?: string }) => {
    if (payload?.clickType) {
      handleDisclaimerTrackEvent(payload.clickType);
    }
  };

  return (
    <div id="disclaimer" className="md:px-4 md:py-3">
      <DisclaimerWithReadMore
        content={{
          colorSelection: "#f5f5f5",
          description: disclaimertext,
          "event-prop-heading": "disclaimer",
          heading: title,
          isDisclaimerWithReadMore: "true",
          isInfoVariation: "false",
          showOnApp: "true",
          showOnWeb: "true",
        }}
        trackEvent={trackEvent}
      />
    </div>
  );
};

export default AMCDisclaimer;
